type TCtaButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  theme: string;
  disabled?: boolean;
};

export function CtaButton({
  children,
  onClick,
  theme,
  disabled,
}: TCtaButtonProps) {
  return (
    <button
      onClick={onClick}
      type="button"
      disabled={disabled}
      className={`${theme} shadow-md shadow-gray-300 font-century-gothic-bold text-sm rounded-[10px] text-theme-black h-min px-10 x flex justify-center items-center`}
    >
      {children}
    </button>
  );
}
